import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Helmet } from "react-helmet";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import HomePage from "@/pages/Home";
import ServicesPage from "@/pages/Services";
import GalleryPage from "@/pages/Gallery";
import ContactPage from "@/pages/Contact";
import BookingPage from "@/pages/Booking";
import CareersPage from "@/pages/Careers";
import AdminPage from "@/pages/Admin";
import FAQPage from "@/pages/FAQ";
import BlogPage from "@/pages/Blog";
import ServiceAreaPage from "@/pages/ServiceArea";
import CustomerPortalPage from "@/pages/CustomerPortal";
import ReferralPage from "@/pages/Referral";
import { Toaster } from "@/components/ui/sonner";
import { GoogleAnalytics, initGA } from "@/utils/analytics";
import { useEffect, useCallback } from "react";

function App() {
  // Memoize initGA to prevent unnecessary re-creation
  const initialize = useCallback(() => {
    initGA();
  }, []);

  useEffect(() => {
    // Initialize Google Analytics
    initialize();
  }, [initialize]);

  return (
    <div className="App">
      <Helmet>
        <title>Taylormade Professional Cleaning Service | Lexington KY | Since 1983</title>
        <meta name="description" content="Professional residential and commercial cleaning services in Lexington, KY. Licensed, insured, and trusted since 1983. Serving 100-mile radius. Free quotes available." />
        <meta name="keywords" content="cleaning service lexington ky, professional cleaners, residential cleaning, commercial cleaning, deep cleaning, post construction cleaning, gym cleaning, restaurant cleaning, warehouse cleaning, air bnb cleaning" />
        <meta property="og:title" content="Taylormade Professional Cleaning Service | Lexington KY" />
        <meta property="og:description" content="40+ years of professional cleaning excellence in Lexington, KY and surrounding areas. Licensed & insured." />
        <meta property="og:type" content="website" />
        <meta name="twitter:card" content="summary_large_image" />
        <link rel="canonical" href="https://tpcslex.org" />
      </Helmet>
      
      <BrowserRouter>
        <GoogleAnalytics />
        <Navbar />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/services" element={<ServicesPage />} />
          <Route path="/gallery" element={<GalleryPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/booking" element={<BookingPage />} />
          <Route path="/careers" element={<CareersPage />} />
          <Route path="/admin" element={<AdminPage />} />
          <Route path="/faq" element={<FAQPage />} />
          <Route path="/blog" element={<BlogPage />} />
          <Route path="/service-area" element={<ServiceAreaPage />} />
          <Route path="/portal" element={<CustomerPortalPage />} />
          <Route path="/referral" element={<ReferralPage />} />
        </Routes>
        <Footer />
        <Toaster />
      </BrowserRouter>
    </div>
  );
}

export default App;
